import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import routes from '../routes';

const QuizListScreen = lazy(() => import('../../screens/Quiz/screens/List'));
const QuizEditScreen = lazy(() => import('../../screens/Quiz/screens/Edit'));

const quizRoutes = [
    <Route
        exact
        key={routes.QUIZ_LIST}
        path={routes.QUIZ_LIST}
        render={() => (
            <Authenticated>
                <QuizListScreen />
            </Authenticated>
        )}
    />,
    <Route
        exact
        key={routes.QUIZ_ANSWER_EDIT}
        path={routes.QUIZ_ANSWER_EDIT}
        render={() => (
            <Authenticated>
                <QuizEditScreen />
            </Authenticated>
        )}
    />,
];

export default quizRoutes;
